export default {
    bindings: {
        orders: '<',
        deleted: '<',
    },
    controller: 'orderListController',
    template: require('../views/order.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.list.component.js